import React, { useState, useEffect } from 'react';
import { Bell, X } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const API = process.env.REACT_APP_BACKEND_URL;
const VAPID_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  return Uint8Array.from([...raw].map(c => c.charCodeAt(0)));
}

export default function PushPrompt() {
  const { t } = useLanguage();
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!('serviceWorker' in navigator) || !('PushManager' in window) || !VAPID_KEY) return;
    const dismissed = localStorage.getItem('ct_push_dismissed');
    const subscribed = localStorage.getItem('ct_push_subscribed');
    if (dismissed || subscribed) return;
    const timer = setTimeout(() => setShow(true), 5000);
    return () => clearTimeout(timer);
  }, []);

  const handleSubscribe = async () => {
    setLoading(true);
    try {
      const reg = await navigator.serviceWorker.register('/push-sw.js');
      const sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(VAPID_KEY),
      });
      const localUser = JSON.parse(localStorage.getItem('ct_user') || 'null');
      await fetch(`${API}/api/push/subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ subscription: sub.toJSON(), email: localUser?.email || '' }),
      });
      localStorage.setItem('ct_push_subscribed', 'true');
      setShow(false);
    } catch (err) {
      console.error('Push subscription error:', err);
    } finally { setLoading(false); }
  };

  const handleDismiss = () => {
    localStorage.setItem('ct_push_dismissed', Date.now().toString());
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-20 right-6 z-50 max-w-sm animate-fade-in" data-testid="push-prompt">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl border border-gray-200 dark:border-gray-700 p-5">
        <button onClick={handleDismiss} className="absolute top-3 right-3 text-gray-300 hover:text-gray-500"><X size={16} /></button>
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-full bg-terracotta/10 flex items-center justify-center flex-shrink-0">
            <Bell size={18} className="text-terracotta" />
          </div>
          <div>
            <p className="font-medium text-navy dark:text-white text-sm">Primajte obavijesti</p>
            <p className="text-xs text-gray-400 mt-1">Budite prvi koji saznaju najnovije vijesti iz Hrvatske.</p>
            <div className="flex gap-2 mt-3">
              <button onClick={handleSubscribe} disabled={loading} data-testid="push-subscribe-btn"
                className="px-4 py-2 bg-terracotta text-white rounded-lg text-xs font-medium hover:bg-terracotta-dark disabled:opacity-50 transition-colors">
                {loading ? 'Pretplata...' : 'Da, želim'}
              </button>
              <button onClick={handleDismiss} className="px-4 py-2 text-gray-400 text-xs hover:text-gray-600">
                Ne hvala
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
